/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ThankYouImport } from './routes/thank-you'
import { Route as PaymentFailedImport } from './routes/payment-failed'
import { Route as LandingEvalDemoImport } from './routes/landing-eval-demo'
import { Route as ImageEvalDemoImport } from './routes/image-eval-demo'
import { Route as GetStartedImport } from './routes/get-started'
import { Route as ContactUsImport } from './routes/contact-us'
import { Route as AdcopyEvalDemoImport } from './routes/adcopy-eval-demo'
import { Route as AboutImport } from './routes/about'
import { Route as IndexImport } from './routes/index'

// Create/Update Routes

const ThankYouRoute = ThankYouImport.update({
  id: '/thank-you',
  path: '/thank-you',
  getParentRoute: () => rootRoute,
} as any)

const PaymentFailedRoute = PaymentFailedImport.update({
  id: '/payment-failed',
  path: '/payment-failed',
  getParentRoute: () => rootRoute,
} as any)

const LandingEvalDemoRoute = LandingEvalDemoImport.update({
  id: '/landing-eval-demo',
  path: '/landing-eval-demo',
  getParentRoute: () => rootRoute,
} as any)

const ImageEvalDemoRoute = ImageEvalDemoImport.update({
  id: '/image-eval-demo',
  path: '/image-eval-demo',
  getParentRoute: () => rootRoute,
} as any)

const GetStartedRoute = GetStartedImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => rootRoute,
} as any)

const ContactUsRoute = ContactUsImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRoute,
} as any)

const AdcopyEvalDemoRoute = AdcopyEvalDemoImport.update({
  id: '/adcopy-eval-demo',
  path: '/adcopy-eval-demo',
  getParentRoute: () => rootRoute,
} as any)

const AboutRoute = AboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/adcopy-eval-demo': {
      id: '/adcopy-eval-demo'
      path: '/adcopy-eval-demo'
      fullPath: '/adcopy-eval-demo'
      preLoaderRoute: typeof AdcopyEvalDemoImport
      parentRoute: typeof rootRoute
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsImport
      parentRoute: typeof rootRoute
    }
    '/get-started': {
      id: '/get-started'
      path: '/get-started'
      fullPath: '/get-started'
      preLoaderRoute: typeof GetStartedImport
      parentRoute: typeof rootRoute
    }
    '/image-eval-demo': {
      id: '/image-eval-demo'
      path: '/image-eval-demo'
      fullPath: '/image-eval-demo'
      preLoaderRoute: typeof ImageEvalDemoImport
      parentRoute: typeof rootRoute
    }
    '/landing-eval-demo': {
      id: '/landing-eval-demo'
      path: '/landing-eval-demo'
      fullPath: '/landing-eval-demo'
      preLoaderRoute: typeof LandingEvalDemoImport
      parentRoute: typeof rootRoute
    }
    '/payment-failed': {
      id: '/payment-failed'
      path: '/payment-failed'
      fullPath: '/payment-failed'
      preLoaderRoute: typeof PaymentFailedImport
      parentRoute: typeof rootRoute
    }
    '/thank-you': {
      id: '/thank-you'
      path: '/thank-you'
      fullPath: '/thank-you'
      preLoaderRoute: typeof ThankYouImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/adcopy-eval-demo': typeof AdcopyEvalDemoRoute
  '/contact-us': typeof ContactUsRoute
  '/get-started': typeof GetStartedRoute
  '/image-eval-demo': typeof ImageEvalDemoRoute
  '/landing-eval-demo': typeof LandingEvalDemoRoute
  '/payment-failed': typeof PaymentFailedRoute
  '/thank-you': typeof ThankYouRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/adcopy-eval-demo': typeof AdcopyEvalDemoRoute
  '/contact-us': typeof ContactUsRoute
  '/get-started': typeof GetStartedRoute
  '/image-eval-demo': typeof ImageEvalDemoRoute
  '/landing-eval-demo': typeof LandingEvalDemoRoute
  '/payment-failed': typeof PaymentFailedRoute
  '/thank-you': typeof ThankYouRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/adcopy-eval-demo': typeof AdcopyEvalDemoRoute
  '/contact-us': typeof ContactUsRoute
  '/get-started': typeof GetStartedRoute
  '/image-eval-demo': typeof ImageEvalDemoRoute
  '/landing-eval-demo': typeof LandingEvalDemoRoute
  '/payment-failed': typeof PaymentFailedRoute
  '/thank-you': typeof ThankYouRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/adcopy-eval-demo'
    | '/contact-us'
    | '/get-started'
    | '/image-eval-demo'
    | '/landing-eval-demo'
    | '/payment-failed'
    | '/thank-you'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/adcopy-eval-demo'
    | '/contact-us'
    | '/get-started'
    | '/image-eval-demo'
    | '/landing-eval-demo'
    | '/payment-failed'
    | '/thank-you'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/adcopy-eval-demo'
    | '/contact-us'
    | '/get-started'
    | '/image-eval-demo'
    | '/landing-eval-demo'
    | '/payment-failed'
    | '/thank-you'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AdcopyEvalDemoRoute: typeof AdcopyEvalDemoRoute
  ContactUsRoute: typeof ContactUsRoute
  GetStartedRoute: typeof GetStartedRoute
  ImageEvalDemoRoute: typeof ImageEvalDemoRoute
  LandingEvalDemoRoute: typeof LandingEvalDemoRoute
  PaymentFailedRoute: typeof PaymentFailedRoute
  ThankYouRoute: typeof ThankYouRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AdcopyEvalDemoRoute: AdcopyEvalDemoRoute,
  ContactUsRoute: ContactUsRoute,
  GetStartedRoute: GetStartedRoute,
  ImageEvalDemoRoute: ImageEvalDemoRoute,
  LandingEvalDemoRoute: LandingEvalDemoRoute,
  PaymentFailedRoute: PaymentFailedRoute,
  ThankYouRoute: ThankYouRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/about",
        "/adcopy-eval-demo",
        "/contact-us",
        "/get-started",
        "/image-eval-demo",
        "/landing-eval-demo",
        "/payment-failed",
        "/thank-you"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/about": {
      "filePath": "about.tsx"
    },
    "/adcopy-eval-demo": {
      "filePath": "adcopy-eval-demo.tsx"
    },
    "/contact-us": {
      "filePath": "contact-us.tsx"
    },
    "/get-started": {
      "filePath": "get-started.tsx"
    },
    "/image-eval-demo": {
      "filePath": "image-eval-demo.tsx"
    },
    "/landing-eval-demo": {
      "filePath": "landing-eval-demo.tsx"
    },
    "/payment-failed": {
      "filePath": "payment-failed.tsx"
    },
    "/thank-you": {
      "filePath": "thank-you.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
